import { Link } from 'react-router-dom';
import { categoryInfo } from '@/mocks/movies';

const categoryOrder: Array<keyof typeof categoryInfo> = ['movie', 'tv', 'variety', 'anime'];

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-8">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4">
        {categoryOrder.map((key) => {
          const cat = categoryInfo[key];
          return (
            <Link
              key={key}
              to={`/category/${key}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-100 hover:bg-primary-50 transition-colors duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <div className="text-center">
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-1">
                  {cat.description}
                </p>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}